import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Menu } from 'antd'
import { Link, useLocation } from 'react-router-dom'
import * as Icons from '@ant-design/icons'

const CustomMenu = ({ menu }) => {
    const [openKeys, setOpenKeys] = useState([])
    const [selectedKeys, setSelectedKeys] = useState([])
    const location = useLocation()

    // 处理 pathname
    const getOpenKeys = (pathname) => {
        let newStr = ''
        let newArr = []
        const arr = pathname.split('/').map(i => '/' + i)
        for (let i = 1; i < arr.length - 1; i++) {
            newStr += arr[i]
            newArr.push(newStr)
        }
        return newArr
    }

    // 动态渲染图标
    const renderIcon = (iconName) => {
        if (!iconName) return null
        
        // Ant Design 图标名称映射
        const iconMap = {
            'home': 'HomeOutlined',
            'user': 'UserOutlined',
            'setting': 'SettingOutlined',
            'appstore': 'AppstoreOutlined',
            'team': 'TeamOutlined',
            'file': 'FileOutlined',
            'bar-chart': 'BarChartOutlined',
            'cloud': 'CloudOutlined',
            'github': 'GithubOutlined',
            'menu': 'MenuOutlined',
            'dashboard': 'DashboardOutlined'
        }

        const iconComponentName = iconMap[iconName] || iconName
        const IconComponent = Icons[iconComponentName]
        
        return IconComponent ? React.createElement(IconComponent) : null
    }

    // 将菜单数据转换为 items 格式
    const convertToItems = (menuData) => {
        if (!menuData) return []

        return menuData.map(item => {
            const menuItem = {
                key: item.key,
                icon: renderIcon(item.icon),
                label: item.subs?.length > 0 ? (
                    <span>{item.title}</span>
                ) : (
                    <Link to={item.key}>{item.title}</Link>
                )
            }

            // 如果有子菜单，递归处理
            if (item.subs?.length > 0) {
                menuItem.children = convertToItems(item.subs)
            }

            return menuItem
        })
    }

    // 页面加载和路由变化时更新菜单状态
    useEffect(() => {
        const { pathname } = location
        setSelectedKeys([pathname])
        setOpenKeys(getOpenKeys(pathname))
    }, [location])

    // 只展开一个 SubMenu
    const onOpenChange = (keys) => {
        if (keys.length === 0 || keys.length === 1) {
            setOpenKeys(keys)
            return
        }

        const latestOpenKey = keys[keys.length - 1]
        if (latestOpenKey.includes(keys[0])) {
            setOpenKeys(keys)
        } else {
            setOpenKeys([latestOpenKey])
        }
    }

    return (
        <Menu
            mode="inline"
            theme="dark"
            openKeys={openKeys}
            selectedKeys={selectedKeys}
            onOpenChange={onOpenChange}
            items={convertToItems(menu)}
        />
    )
}

CustomMenu.propTypes = {
    menu: PropTypes.array.isRequired
}

export default CustomMenu